import React from 'react';

import { createClassName } from 'utils/createClassName';
import { ArrowLeftMobileIcon } from 'svg/24x24/arrow-left-mobile';
import { ArrowLeftIcon } from 'svg/16x16/arrow-left';
import { useIsMobile } from 'hooks/useIsMobile';
import { ClickControlComponent } from 'design/clickControl/clickControlComponents';
import { ServicePageNavigationPortal } from 'design/servicePageNavigationPortalComponents';

import './backControlStyles.scss';
import { TextComponent } from 'design/text/textComponents';

type Props = {
  onPress(): void;
};

export const BackControlComponent = (props: Props) => {
  const { onPress } = props;

  const isMobileView = useIsMobile();

  const className = createClassName('backControl')({
    mobileView: isMobileView,
    desktopView: !isMobileView,
  });

  const handleClick = React.useCallback(() => {
    onPress();
  }, [onPress]);

  if (isMobileView) {
    return (
      <ServicePageNavigationPortal>
        <ClickControlComponent onClick={handleClick}>
          <TextComponent color="primary">
            <ArrowLeftMobileIcon />
          </TextComponent>
        </ClickControlComponent>
      </ServicePageNavigationPortal>
    );
  }

  return (
    <button type="button" className={className} onClick={handleClick}>
      <TextComponent color="primary">
        <ArrowLeftIcon />
      </TextComponent>
    </button>
  );
};
